import { Menu } from '@shared/components/Menu';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { useMonthOptions } from './hooks/useMonthOptions';

export function MonthOptionsDesktop({
  rruleOptions,
  setRruleOptions,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const {
    dateSelectOptions,
    nthSelectOptions,
    daySelectOptions,
    handleDayOfMonthSelect,
    handleFullNthSelect,
    isDayOfMonthSelected,
    isNthWeekdaySelected,
    dayOfMonthDisplay,
    nthDayDisplay,
    nthDayWeekdayDisplay,
  } = useMonthOptions({ rruleOptions, setRruleOptions });

  return (
    <View gap={1}>
      <Text size="body1" weight="semibold">
        {i18n('workflowTemplate.component.dateAndRepeat.onDotDotDot')}
      </Text>
      <View row centerVertically gap={1}>
        <MBTouchableOpacity onPress={handleDayOfMonthSelect}>
          {isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(4)} />
          )}

          {!isDayOfMonthSelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(4)} />
          )}
        </MBTouchableOpacity>
        <Menu>
          <Menu.Button flex label={dayOfMonthDisplay} />
          <Menu.Content>
            <Menu.Options
              options={dateSelectOptions}
              onSelect={option => option.onPress()}
              getItemKey={option => option.title}
              getItemLabel={option => option.title}
            />
          </Menu.Content>
        </Menu>
      </View>
      <View row centerVertically gap={1}>
        <MBTouchableOpacity onPress={handleFullNthSelect}>
          {isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="radio-button" size={grid(4)} />
          )}
          {!isNthWeekdaySelected && (
            <MBIconV2 color={Colors.v2.green} name="unfilled-circle" size={grid(4)} />
          )}
        </MBTouchableOpacity>
        <Menu>
          <Menu.Button label={nthDayDisplay} />
          <Menu.Content>
            <Menu.Options
              options={nthSelectOptions}
              onSelect={option => option.onPress()}
              getItemKey={option => option.title}
              getItemLabel={option => option.title}
            />
          </Menu.Content>
        </Menu>
        <Menu>
          <Menu.Button flex label={nthDayWeekdayDisplay} />
          <Menu.Content>
            <Menu.Options
              options={daySelectOptions}
              onSelect={option => option.onPress()}
              getItemKey={option => option.title}
              getItemLabel={option => option.title}
            />
          </Menu.Content>
        </Menu>
      </View>
    </View>
  );
}
